import { AvailableModuleinfo, EnabledModuleInfo } from '../constants/paidModuleTypes';
import { EntityType } from '../constants/user-info/ENTITY_TYPES';
import { apiService } from './apiService';

const getAvailableModules = async (entityType: EntityType) => {
  const params = { entity_type: entityType };

  const resp = await apiService.get<AvailableModuleinfo[]>(
    'api/paid-service/available-types',
    { params },
  );

  return resp.data;
};

const getEnabledModules = async (entityId: number) => {
  const resp = await apiService.get<EnabledModuleInfo[]>(
    `api/paid-service/entity/${entityId}/enabled_modules`,
  );

  return resp.data;
};

const getCustomerAvailableModules = async (customerId: number) => {
  const resp = await apiService.get<AvailableModuleinfo[]>(
    `api/paid-service/customer/${customerId}/available_modules`,
  );

  return resp.data;
};

export const paidModulesService = {
  getEnabledModules,
  getAvailableModules,
  getCustomerAvailableModules,
};
